export default "__VITE_ASSET__8806aed3__"